module.exports = __webpack_public_path__ + "static/img/cont60 (3).e876f8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont60 (3).jpg
// module id = /S8o
// module chunks = 0